module.exports = __webpack_public_path__ + "static/media/instagram-logo.9e579f62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram-logo.svg
// module id = 368
// module chunks = 0